import { AIDA_INTRO_SEEN_KEY, LEGACY_AIDA_INTRO_SEEN_KEY } from './constants/storage-keys'

export function migrateLegacyIntroSeen() {
  try {
    if (window.localStorage.getItem(AIDA_INTRO_SEEN_KEY) === '1') {
      window.localStorage.removeItem(LEGACY_AIDA_INTRO_SEEN_KEY)
      return
    }
    if (window.localStorage.getItem(LEGACY_AIDA_INTRO_SEEN_KEY) === '1') {
      window.localStorage.setItem(AIDA_INTRO_SEEN_KEY, '1')
    }
    window.localStorage.removeItem(LEGACY_AIDA_INTRO_SEEN_KEY)
  } catch {
    return
  }
}

export function readAidaIntroSeen() {
  try {
    return window.localStorage.getItem(AIDA_INTRO_SEEN_KEY) === '1'
  } catch {
    return false
  }
}

export function markAidaIntroSeen() {
  try {
    window.localStorage.setItem(AIDA_INTRO_SEEN_KEY, '1')
    window.localStorage.removeItem(LEGACY_AIDA_INTRO_SEEN_KEY)
  } catch {
    // Private mode can reject writes. The in-memory flag still finishes this visit.
  }
}
